/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

if (typeof window.themeObj === 'undefined') {
  window.themeObj = {
    tools: {},
    templates: {},
    sections: {}
  };
}

window.themeObj.tools = {
  money: (price) => {
    var currencyFormat = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;

    if (!currencyFormat.includes('<span class="notranslate ht-money">')) {
      currencyFormat = `<span class="notranslate ht-money">${currencyFormat}</span>`;

      if (currencyFormat.includes('amount_with_comma_separator')) {
        currencyFormat = currencyFormat.replace(/amount\_with\_comma\_separator/, 'amount');
      }
    }

    const moneyText = (Number(price) / 100).toFixed(2);
    
    const newCurrencyFormat = currencyFormat.replace(/\{\{amount\}\}/, moneyText);
    return newCurrencyFormat;
  },
  insertAfter: function(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  },
  formToJson: function(elements) {
    return [].reduce.call(elements, function (data, element) {
      data[element.name] = element.value;
      return data;
    }, {});
  },
  getUrlString: function(data) {
    var urlParameters = Object.entries(data).map(function (e) {
      return e.join('=');
    }).join('&');
  
    return urlParameters;
  },
  getUrlParameter: function(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : sParameterName[1];
      }
    }
  }
};

window.themeObj.templates.checkout = {
  init: function() {
    window.themeObj.templates.checkout.steps();
    
    window.themeObj.templates.checkout.informationStep.init();
    window.themeObj.templates.checkout.shippingStep();
    window.themeObj.templates.checkout.paymentStep();
  },
  informationStep: {
    init: function() {

      const checkPhoneFieldInterval = setInterval(function() {
        const field = document.querySelector('.address-fields .field[data-address-field="phone"]');
    
        if (field) {
          clearInterval(checkPhoneFieldInterval);
          window.themeObj.templates.checkout.informationStep.checkPhoneField(false);
        }
      }, 500);
  
      checkPhoneFieldInterval;

      /* Country field */
      $(document).on('change', '.floating-labels .field--show-floating-label .field__input[name="checkout[shipping_address][country]"]', function() {
        const fieldInput = $(this);
        const fieldInputValue = fieldInput.val();
        
        const phoneFieldInput = $('.address-fields .field[data-address-field="phone"] .field__input[name="checkout[shipping_address][phone]"]');
        const phoneFieldInputValue = phoneFieldInput.val().trim();
    
        if (fieldInputValue == 'Mexico') {
          
          if (phoneFieldInputValue.length < 3) {
            var newPhoneInputValue = '52';
            phoneFieldInput.val(newPhoneInputValue);
            
          } else {
            var newPhoneInputValue = phoneFieldInputValue.replace(/^(.{2})/, '52');
            phoneFieldInput.val(newPhoneInputValue);
          }
        }

        window.themeObj.templates.checkout.informationStep.checkPhoneField(false);
      });
      /* /Country field */
      
      /* Phone field */
      $(document).on('change keydown keyup keypress', '.field__input-wrapper--icon-right .field__input[name="checkout[shipping_address][phone]"]', function() {
        window.themeObj.templates.checkout.informationStep.checkPhoneField(true);
      });
      /* /Phone field */

      /* Contunue shopping */
      $(document).on('click', '#continue_button--cloned', function() {
        const button = $(this);
        
        window.themeObj.templates.checkout.informationStep.checkPhoneField(true);
        
        const phoneField = $('.address-fields .field[data-address-field="phone"]');

        if (phoneField.hasClass('field--error')) {
          button.addClass('is-visible');
          
        } else {
          button.removeClass('is-visible');
          
          const originalButton = $('#continue_button');
          originalButton.click();
        }
      });
      /* /Contunue shopping */
    },
    checkPhoneField: function(showErrorMessage) {
      const continueButton = $('#continue_button');
      var continueButtonCloned = $('#continue_button--cloned');
      
      if (!continueButtonCloned.length) {
        continueButtonCloned = continueButton.clone();
        continueButtonCloned.attr('id', 'continue_button--cloned').attr('type', 'button');
        continueButton.before(continueButtonCloned);
        
        continueButtonCloned = $('#continue_button--cloned');
      }
      
      const field = $('.address-fields .field[data-address-field="phone"]');

      if (field.length) {
        const fieldInput = field.find('.field__input[name="checkout[shipping_address][phone]"]');

        if (fieldInput.length) {
          const fieldInputValue = fieldInput.val().trim();
          const fieldInputClearValue = fieldInputValue.replaceAll(' ', '');
          
          const fieldMessage = field.find('.field__message');
          var fieldHasError = field.hasClass('field--error');
  
          if (!fieldMessage.length) {
            field.children('.field__input-wrapper').after(
              '<p class="field__message field__message--error" id="error-for-phone">Enter valid a phone number</p>'
            );
          }
          
          const countryFieldInput = $('.floating-labels .field--show-floating-label .field__input[name="checkout[shipping_address][country]"]');

          if (countryFieldInput.length) {
            const countryFieldInputValue = countryFieldInput.val().trim();
            
            if (countryFieldInputValue == 'Mexico') {
              
              if (fieldInputClearValue.length < 3) {
                var newFieldInputValue = '52';
                fieldInput.val(newFieldInputValue);
                
              } else {
                var newFieldInputValue = fieldInputValue.replace(/^(.{2})/, '52');
                fieldInput.val(newFieldInputValue);
              }
            }
  
            if (countryFieldInputValue == 'Mexico' && fieldInputClearValue.length < 12) {
              fieldHasError = true;
    
            } else {
              fieldHasError = false;
            }
            
            if (!fieldInputClearValue.length) {
              fieldHasError = true;
            }
    
            if (fieldHasError) {
              continueButtonCloned.addClass('is-visible');
    
              if (showErrorMessage) {
                field.addClass('field--error');
              }
              
            } else {
              continueButtonCloned.removeClass('is-visible');
              field.removeClass('field--error');
            }
          }
        }
        
      } else {
        continueButtonCloned.removeClass('is-visible');
      }
    }
  },
  shippingStep: function() {
    const shipping = $('.section--shipping-address');

    // if (shipping.length) {
    //   const currencyMessage = $('.section--shipping-address__currency-message');

    //   if (currencyMessage.length) {
    //     currencyMessage.removeAttr('style');
    //     shipping.before(currencyMessage);
    //   }
    // }

    /* SMS */
    const shippingStepSmsInterval = setInterval(function() {
      const emailField = document.getElementById('checkout_email_or_phone');
  
      if (emailField) {
        const emailFieldValue = emailField.value.trim();
  
        if (!emailFieldValue.length) {
          const smsCheckbox = document.getElementById('ps_accepts_sms');
      
          if (smsCheckbox) {
            clearInterval(shippingStepSmsInterval);
      
            if (!smsCheckbox.checked) {
              smsCheckbox.click();
              localStorage.removeItem('shopify-checkout--last-step');
            }
          }
        }
      }
    }, 500);

    shippingStepSmsInterval;
    /* /SMS */
  },
  paymentStep: function() {
    /* Credential BR field */
    $(document).on('change keyup keydown keypress', '.floating-labels .field--show-floating-label .field__input[name="checkout[localized_fields][shipping_credential_br]"]', function() {
      const field = $(this);
      const fieldValue = field.val().trim();
      
      field.attr('maxlength', 14);

      var newFieldValue = '';
      var symbolI = 0;
      
      for (var i = 0; i < fieldValue.length; i++) {
        const symbol = fieldValue[i];
      	
        if (/^[0-9]{1}$/.test(symbol) && symbolI < 11) {
          newFieldValue += symbol;
          
          switch (symbolI) {
          	case 2:
          		newFieldValue += '.';
            	break;
          	case 5:
          		newFieldValue += '.';
            	break;
          	case 8:
          		newFieldValue += '-';
            	break;
          }
          
          symbolI++;
        }
      }

      field.val(newFieldValue);
    });
    /* /Credential BR field */
  },
  cartItems: function(cartItems) {

    if (cartItems.length) {
      const checkoutItems = $('.product-table .product[data-variant-id]');
  
      checkoutItems.each(function() {
        const checkoutItem = $(this);

        if (!checkoutItem.hasClass('is-localized')) {
          const checkoutItemVariantId = checkoutItem.attr('data-variant-id');
          
          const checkoutItemVariant = checkoutItem.find('.product__description__variant');
          const checkoutItemVariantText = checkoutItemVariant.text().trim();
    
          var cartItem = cartItems.find('.CartItem[data-variant-id="' + checkoutItemVariantId + '"]:first');
    
          if (cartItem.length) {
            var cartItemVariant = cartItem.find('.CartItem__Variant');
    
            if (cartItemVariant.length) {
              const cartItemVariantText = cartItemVariant.text();
              checkoutItemVariant.text(cartItemVariantText);
            }
    
            const checkoutItemDiscount = checkoutItem.find('.reduction-code__text');
            const cartItemDiscount = cartItem.find('.CartItem__DiscountCode');
    
            if (checkoutItemDiscount.length && cartItem.length) {
              checkoutItemDiscount.text(cartItemDiscount.attr('data-text'));
            }
          }

          checkoutItem.addClass('is-localized');
        }
      });
    }
  },
  steps: function() {
    
    $(document).ready(function(){
  
      $.ajax({
        url: '/cart',
        type: 'GET',
        dataType: 'html',
        success: function (data) {
          const cartItems = $(data).find('.Cart__ItemList');

          setInterval(function() {
            window.themeObj.templates.checkout.cartItems(cartItems);
          }, 1000);
        }
      });
      
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const page_type = urlParams.get('step');

      let newUrl = window.location.href.split('?')[0];

      var lastSavedStepNumber = localStorage.getItem('shopify-checkout--last-step');

      if (lastSavedStepNumber) {
        lastSavedStepNumber = parseInt(lastSavedStepNumber);
      
      } else {
        lastSavedStepNumber = 1;
      }

      $('.progressbar li[id="zero_step"] a').attr("href", '/cart');

      if (page_type == 'contact_information'  || ( $('.step').attr('data-step') == 'contact_information' )) {
        $('.progressbar li[id="first_step"]').addClass('active checked');
        
        var currentStepNumber = 1;

      } else if (page_type == 'shipping_method' || ( $('.step').attr('data-step') == 'shipping_method' )) {
        $('.progressbar li[id="first_step"]').addClass('checked');
        $('.progressbar li[id="first_step"] a').attr("href", newUrl+'\?step=contact_information');
        $('.progressbar li[id="second_step"]').addClass('active checked');
        
        var currentStepNumber = 2;

      } else if (page_type == 'payment_method' || ( $('.step').attr('data-step') == 'payment_method' ) || ( $('.step').attr('data-step') == 'thank_you' )) {
        $('.progressbar li[id="first_step"], .progressbar > li[id="second_step"]').addClass('checked');
        $('.progressbar li[id="first_step"] a').attr("href", newUrl+'\?step=contact_information');
        $('.progressbar li[id="second_step"] a').attr("href", newUrl+'\?step=shipping_method');
        $('.progressbar li[id="third_step"]').addClass('active checked');
        
        var currentStepNumber = 3;
      }

      if (currentStepNumber > lastSavedStepNumber) {
        lastSavedStepNumber = currentStepNumber;
        localStorage.setItem('shopify-checkout--last-step', currentStepNumber);
      }

      if (lastSavedStepNumber == 2) {
        $('.progressbar li[id="third_step"]').addClass('disabled');
      
      } else if (lastSavedStepNumber == 1) {
        $('.progressbar li[id="second_step"]').addClass('disabled');
        $('.progressbar li[id="third_step"]').addClass('disabled');
      }

      updateContainer();
      $(window).resize(function() {
          updateContainer();
      });
      
      function updateContainer() {
        var $containerWidth = $(window).width();
        
        if ($containerWidth <= 999) {
          $('.wrap a.logo').hide();
          $('.progress_wrap').prependTo('header.banner');
          $('.benefits_block').appendTo('.main__content');
          
        } else if ($containerWidth > 999) {
          $('.progress_wrap').appendTo('.main__header');
          $('.benefits_block').appendTo('.sidebar');
        }
      }
    });
  }
};

if (document.body.classList.contains('template-checkout')) {
  window.themeObj.templates.checkout.init();
}

window.themeObj.sections = {
  init: () => {
    window.themeObj.sections.loading();
    
    window.themeObj.sections.cartDrawer();

    if (document.documentElement.getAttribute('lang') != 'en') {
      window.themeObj.sections.footer.klaviyo.init();
      window.themeObj.sections.tracktor.init();
      window.themeObj.sections.discountKlaviyoPopup.init();
    }

    setTimeout(() => {
      window.themeObj.sections.contactPopup.init();
    }, 500);

    new window.themeObj.sections.cartDrawerRecommended();
  },
  cartDrawer: () => {
    const drawer = document.getElementById('sidebar-cart');

    if (drawer) {
      const cartDrawerResize = () => {

        if (drawer.getAttribute('aria-hidden')) {
          const drawerFooter = drawer.querySelector('.Drawer__Footer');
    
          if (drawerFooter) {
            const drawerFooterHeight = drawerFooter.clientHeight;
            drawer.style.setProperty('--footer-height', `${drawerFooterHeight}px`);
          }
        }
      };
      
      window.addEventListener('resize', cartDrawerResize);
      
      setInterval(function() {
        cartDrawerResize();
      }, 1000);
      
      cartDrawerResize();
    }
  },
  cartDrawerRecommended: class {

    data = {}

    constructor() {
      const obj = this;
      
      document.addEventListener('theme:cart:rendered', (event) => {
        const cartUpsellItem = document.querySelector('#sidebar-cart .CartItem.Removed[data-product-type="upsell"]');

        if (cartUpsellItem || event.detail.upsell) {
          return false;
        }
        
        obj.render();
      });
    }

    render() {
      const obj = this;

      const url = '/cart/?section_id=cart-drawer-recommended';

      fetch(url)
        .then(response => response.text())
        .then(response => {
          const fetchContent = new DOMParser()
            .parseFromString(response, 'text/html')
            .querySelector('.CartDrawer__Recommended');

          if (!fetchContent) {
            return false;
          }
          
          obj.data.wrapper = document.querySelector('.CartDrawer__Recommended');
          obj.data.wrapper ? obj.data.wrapper.innerHTML = fetchContent.innerHTML : '';

          obj.data.popup = document.querySelector('.CartDrawer__RecommendedPopup');
          obj.hidePopup();

          obj.data.popupBg = document.querySelector('.CartDrawer__RecommendedPopup__Bg');

          obj.data.popupBg.addEventListener('click', () => {
            obj.hidePopup();
          });

          obj.data.popupClose = document.querySelector('.CartDrawer__RecommendedPopup__Close');
          obj.data.popupContent = document.querySelector('.CartDrawer__RecommendedPopup__Content');

          obj.data.items = document.querySelectorAll('.CartDrawer__RecommendedItem');

          if (obj.data.items.length) {

            obj.data.items.forEach((item) => {

              item.addEventListener('click', () => {
                item.classList.add('is-loading');
                const itemHandle = item.getAttribute('data-product-handle');

                obj.renderPopupByProductHandle(itemHandle);
              });
            });

            obj.showMore();

            obj.data.wrapper.classList.add('is-visible');
          }
        });
    }

    renderPopupByProductHandle(productHandle) {
      const obj = this;
      const url = `/products/${productHandle}?section_id=cart-drawer-recommended-popup`;

      fetch(url)
        .then(response => response.text())
        .then(response => {
          const fetchContent = new DOMParser()
            .parseFromString(response, 'text/html')
            .querySelector('.CartDrawer__RecommendedPopup__Content');

          if (!fetchContent) {
            return false;
          }

          const productId = fetchContent.closest('.CartDrawer__RecommendedPopup').getAttribute('data-product-id');
          
          obj.data.popup.setAttribute('data-product-id', productId);
          obj.data.popupContent.innerHTML = fetchContent.innerHTML;

          const loadingItem = document.querySelector('.CartDrawer__RecommendedItem.is-loading');
          loadingItem.classList.remove('is-loading');

          /* Back */
          obj.data.popupBack = document.querySelector('.CartDrawer__RecommendedPopup__Back');

          obj.data.popupBack.addEventListener('click', () => {
            obj.hidePopup();
          });
          /* /Back */

          /* Close */
          obj.data.popupClose = document.querySelector('.CartDrawer__RecommendedPopup__Close');

          obj.data.popupClose.addEventListener('click', () => {
            obj.hidePopup();
          });
          /* /Close */

          const button = document.querySelector('.CartDrawer__RecommendedPopup__Button');

          button.addEventListener('click', () => {
            obj.addToCart();
          });

          /* Options */
          const productOptions = document.querySelectorAll('.CartDrawer__RecommendedPopup__FormOption');

          if (productOptions.length) {

            productOptions.forEach((productOption) => {
              let productOptionMinItemOrder = 9999;
              let productOptionMinItem = productOption.querySelector('.CartDrawer__RecommendedPopup__FormOption__Item');
              
              const productOptionItems = productOption.querySelectorAll('.CartDrawer__RecommendedPopup__FormOption__Item[data-order]');
              
              if (productOptionItems.length) {
        
                productOptionItems.forEach((productOptionItem) => {
                  const productOptionItemOrder = parseInt(productOptionItem.getAttribute('data-order'));
        
                  if (productOptionItemOrder > 0 &&
                      productOptionMinItemOrder > productOptionItemOrder) {
                    productOptionMinItemOrder = productOptionItemOrder;
                    productOptionMinItem = productOptionItem;
                  }
                });
              }

              if (productOptionMinItem) {
                productOptionMinItem.classList.add('is-active');
              }
            });
          }
          /* /Options */

          /* Option values */
          const items = document.querySelectorAll('.CartDrawer__RecommendedPopup__FormOption__Item');

          if (items.length) {

            items.forEach((item) => {

              item.addEventListener('click', () => {
                const activeItem = item.parentNode.querySelector('.is-active');

                if (activeItem) {
                  activeItem.classList.remove('is-active');
                }

                const itemProductId = item.getAttribute('data-product-id');
                obj.data.popup.setAttribute('data-product-id', itemProductId);

                item.classList.add('is-active');

                const itemType = item.getAttribute('data-type');

                if (itemType == 'image') {
                  obj.renderPopupProductImage();
                }
                
                obj.popupProductVariantChange();
              });
            });
            /* /Option values */
          }
          
          obj.popupProductVariantChange();

          obj.renderPopupSize();
          obj.showPopup();
        });
    }

    renderPopupSize() {
      const obj = this;
      
      const popup = obj.data.popup.querySelector('.CartDrawer__RecommendedSize__Popup');

      if (!popup) {
        return false;
      }
      
      const content = popup.querySelector('.CartDrawer__RecommendedSize__Content');

      const button = obj.data.popup.querySelector('.CartDrawer__RecommendedPopup__FormOption legend button');

      button.addEventListener('click', () => {
        popup.classList.add('is-visible');
      });

      const bg = obj.data.popup.querySelector('.CartDrawer__RecommendedSize__Bg');

      bg.addEventListener('click', () => {
        popup.classList.remove('is-visible');
      });

      const close = obj.data.popup.querySelector('.CartDrawer__RecommendedSize__Close');

      close.addEventListener('click', () => {
        popup.classList.remove('is-visible');
      });

      const items = popup.querySelectorAll('.size-guide__tab');

      if (!items.length) {
        return false;
      }

      items.forEach((item) => {

        item.addEventListener('click', () => {
          const activeItem = item.parentNode.querySelector('.size-guide__tab--selected');
          activeItem.classList.remove('size-guide__tab--selected');

          item.classList.add('size-guide__tab--selected');

          if (item.classList.contains('guide_tab_cm')) {
            content.classList.remove('active-inch');
            content.classList.add('active-cm');

          } else {
            content.classList.add('active-inch');
            content.classList.remove('active-cm');
          }
        });
      });
    }

    showPopup() {
      const obj = this;
      
      obj.data.popup.classList.add('is-visible');
    }

    hidePopup() {
      const obj = this;
      
      obj.data.popup.classList.remove('is-visible');
    }

    renderPopupProductImage() {
      const obj = this;
      
      const imageButton = obj.data.popup.querySelector('.CartDrawer__RecommendedPopup__FormOption__Item.is-active[data-type="image"]');

      if (!imageButton ||
          !imageButton.hasAttribute('data-image-id')) {
        return false;
      }

      const imageButtonId = imageButton.getAttribute('data-image-id');
      
      const image = obj.data.popup.querySelector(`.CartDrawer__RecommendedPopup__Image[data-image-id="${imageButtonId}"]`);

      if (!image) {
        return false;
      }
      
      const imageIndex = parseInt(image.getAttribute('data-image-index'));

      if (window.innerWidth >= 641) {
        image.parentNode.scrollTop = imageIndex * (image.offsetHeight + 3);

      } else {
        image.parentNode.scrollLeft = imageIndex * (image.offsetWidth + 1);
      }
    }

    getPopupProductId() {
      const obj = this;

      const popup = obj.data.popup;
      
      const productId = popup.getAttribute('data-product-id');
      return productId;
    }

    getPopupProductVariantsById(productId)  {  
      const obj = this;
    
      if (!productId) {
        return null;
      }
      
      const json = obj.data.popup.querySelector(`.CartDrawer__RecommendedPopup_Json script[data-product-id="${productId}"]`);
  
      if (!json) {
        return null;
      }
      
      const jsonText = json.innerHTML;
          
      const productVariants = JSON.parse(json.innerHTML);
      return productVariants;
    }

    getPopupProductVariants()  {
      const obj = this;

      const productId = obj.getPopupProductId();

      if (!productId) {
        return null;
      }
      
      const productVariants = obj.getPopupProductVariantsById(productId);
      return productVariants;
    }

    getPopupProductActiveVariant() {
      const obj = this;

      let activeVariant = null;
      let activeVariantText = '';

      let productId = null;
      
      const activeItems = obj.data.popup.querySelectorAll('.CartDrawer__RecommendedPopup__FormOption__Item.is-active');

      if (!activeItems) {
        return false;
      }

      activeItems.forEach((activeItem, activeItemI) => {
        const activeItemValue = activeItem.getAttribute('data-value');
        const activeItemLocalValue = activeItem.getAttribute('data-local-value');

        const optionLabelValue = activeItem.parentNode.previousElementSibling.querySelector('b');
        optionLabelValue.innerHTML = activeItemLocalValue;

        if (activeItemI) {
          activeVariantText += ' / ';
        }

        activeVariantText += activeItemValue;
        
        const activeItemProductId = activeItem.getAttribute('data-product-id');
        productId = activeItemProductId;
      });
      
      const variants = obj.getPopupProductVariantsById(productId);

      if (!variants) {
        return null;
      }
      
      variants.forEach((variant) => {

        if (variant.title == activeVariantText) {
          activeVariant = variant;
        }
      });
      
      return activeVariant;
    }

    checkPopupProductVariantTitleVisibility(productId, variantTitle) {
      const obj = this;

      let productOptionItemVisibility = false;

      const variants = obj.getPopupProductVariantsById(productId);

      variants.forEach((variant) => {

        if (variant.title == variantTitle) {
          productOptionItemVisibility = true;
        }
      });

      return productOptionItemVisibility;
    }

    renderPopupProductOptionsVisibility() {
      const obj = this;

      const options = obj.data.popup.querySelectorAll('.CartDrawer__RecommendedPopup__FormOption');

      let productId = null;

      if (options.length) {
        let activeImageOptionValueText = '';

        options.forEach((option) => {
          const optionName = option.getAttribute('data-option-name');
          const optionValues = option.querySelectorAll('.CartDrawer__RecommendedPopup__FormOption__Item');

          optionValues.forEach((optionValue) => {
            const optionValueType = optionValue.getAttribute('data-type');
            const optionValueText = optionValue.getAttribute('data-value');
            const optionValueProductId = optionValue.getAttribute('data-product-id');
            
            switch (optionValueType) {

              case 'image':

                if (optionValue.classList.contains('is-active')) {
                  productId = optionValueProductId;
                  activeImageOptionValueText = optionValueText;
                }
                
                break;
                
              case 'button':
                let optionValueVariantTitle = activeImageOptionValueText;

                if (activeImageOptionValueText) {
                  optionValueVariantTitle += ' / ';
                }

                optionValueVariantTitle += optionValueText;

                if (obj.checkPopupProductVariantTitleVisibility(optionValueProductId, optionValueVariantTitle)) {
                  optionValue.classList.remove('is-hidden');
                
                } else {
                  optionValue.classList.add('is-hidden');
                }
                
                break;
            }
          });
        });
      }
    }

    renderPopupProductOptionsAvailability() {
      const obj = this;
      
      const items = obj.data.popup.querySelectorAll('.CartDrawer__RecommendedPopup__FormOption__Item[data-type="button"]');

      if (!items.length) {
        return false;
      }

      const activeVariant = obj.getPopupProductActiveVariant();

      if (!activeVariant) {
        return false;
      }

      /* Buttons: availability */
      const activeImageItem = obj.data.popup.querySelector('.CartDrawer__RecommendedPopup__FormOption__Item.is-active[data-type="image"]');

      if (!activeImageItem) {
        return false;
      }
      
      const activeImageItemValue = activeImageItem.getAttribute('data-value');
      
      const variants = obj.getPopupProductVariants();

      if (!variants) {
        return false;
      }

      items.forEach((item) => {
        const itemValue = item.getAttribute('data-value');

        variants.forEach((itemVariant) => {
          
          if (itemVariant.option1 == activeImageItemValue &&
              itemVariant.option2 == itemValue) {

            if (itemVariant.available) {
              item.classList.add('is-available');
              item.classList.remove('is-sold-out');

            } else {
              item.classList.remove('is-available');
              item.classList.add('is-sold-out');
            }
          }
        });
      });

      items.forEach((item) => {
        const itemValue = item.getAttribute('data-value');

        variants.forEach((itemVariant) => {

          if (
            (itemVariant.option1 == activeVariant.option1 && !itemVariant.option2) &&
            (itemVariant.option1 == activeVariant.option1 && itemVariant.option2 == itemValue)
          ) {

            if (itemVariant.available) {
              item.classList.remove('is-sold-out');

            } else {
              item.classList.add('is-sold-out');
            }
          }
        });
      });
      /* /Buttons: availability  */
    }

    renderPopupProductButtonOption() {
      const obj = this;

      const activeButtonItem = obj.data.popup.querySelector('.CartDrawer__RecommendedPopup__FormOption__Item.is-active:not(.is-hidden)[data-type="button"]');

      if (activeButtonItem) {
        return;
      }

      const availableButtonItems = obj.data.popup.querySelectorAll('.CartDrawer__RecommendedPopup__FormOption__Item:not(.is-hidden):not(.is-sold-out)[data-type="button"]');

      if (availableButtonItems.length) {
        let availableButtonMinItemOrder = 9999;
        let availableButtonMinItem = obj.data.popup.querySelector('.CartDrawer__RecommendedPopup__FormOption__Item:not(.is-hidden):not(.is-sold-out)[data-type="button"]');
  
        availableButtonItems.forEach((availableButtonItem) => {
          const availableButtonItemOrder = parseInt(availableButtonItem.getAttribute('data-order'));

          if (availableButtonItemOrder > 0 &&
              availableButtonMinItemOrder > availableButtonItemOrder) {
            availableButtonMinItemOrder = availableButtonItemOrder;
            availableButtonMinItem = availableButtonItem;
          }
        });

        if (availableButtonMinItem) {
          availableButtonMinItem.click();
          return;
        }
      }
        
      const buttonItem = obj.data.popup.querySelector('.CartDrawer__RecommendedPopup__FormOption__Item:not(.is-hidden)[data-type="button"]');

      if (buttonItem) {
        buttonItem.click();
      }
    }

    popupProductVariantChange() {
      const obj = this;

      obj.renderPopupProductImage();
      
      obj.renderPopupProductOptionsVisibility();
      obj.renderPopupProductOptionsAvailability();
                
      obj.renderPopupProductButtonOption();
      
      obj.renderPopupAddToCart();
    }

    renderPopupAddToCart() {
      const obj = this;

      const button = obj.data.popup.querySelector('.CartDrawer__RecommendedPopup__Button');

      const activeVariant = obj.getPopupProductActiveVariant();

      if (!activeVariant) {
        button.setAttribute('disabled', 'disabled');
        return false;
      }
      
      button.removeAttribute('disabled');
      button.setAttribute('data-variant-id', activeVariant.id);

      const buttonPrice = button.querySelector('.CartDrawer__RecommendedPopup__ButtonPrice');
      buttonPrice.innerHTML = window.themeObj.tools.money(activeVariant.price);

      const buttonText = button.querySelector('span:first-child');

      if (activeVariant.available) {
        button.classList.add('Button--primary');
        button.classList.remove('Button--secondary');
        button.removeAttribute('disabled');

        buttonText.innerHTML = buttonText.getAttribute('data-available');

      } else {
        button.classList.remove('Button--primary');
        button.classList.add('Button--secondary');
        button.setAttribute('disabled', 'disabled');

        buttonText.innerHTML = buttonText.getAttribute('data-sold-out');
      }
    }

    addToCart() {
      const obj = this;
      
      obj.hidePopup();

      const button = document.querySelector('.CartDrawer__RecommendedPopup__Button');
      button.setAttribute('disabled', 'disabled');

      const url = '/cart/add.js';
      const variantId = button.getAttribute('data-variant-id');

      fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            'form_type': 'product',
            'id': variantId,
            'quantity': 1
          })
        })
        .then((response) => response.json())
        .then((response) => {
          button.removeAttribute('disabled');

          // const eventName = 'theme:product:upsell:added';
          // const event = new CustomEvent(eventName);
          // document.dispatchEvent(event);

          document.dispatchEvent(
            new CustomEvent('upsell:added')
          );
        });
    }

    showMore() {
      const button = document.querySelector('.CartDrawer__RecommendedButton');

      if (!button) {
        return false;
      }

      button.addEventListener('click', () => {
        button.remove();

        const items = document.querySelectorAll('.CartDrawer__RecommendedItem');

        if (items.length) {
          
          items.forEach((item) => {
            item.classList.add('is-visible--desktop');
            item.classList.add('is-visible--mobile');
          });
        }
      });
    }
  },
  loading: () => {
    const transition = document.querySelector('.PageTransition');
  
    if (transition) {
      transition.classList.add('PageTransition__loaded');
  
      setInterval(() => {
        
        if (transition.style.opacity) {
          transition.style.opacity = 0;
        }
      }, 2000);
    }
  },
  contactPopup: {
    init: () => {
      const popup = document.querySelector('.ContactPopup');
  
      if (popup) {
        const productGetHelp = document.querySelector('.get_help > center');
        const footerButton = document.querySelector('#section-footer .ContactPopup__Button');
  
        if (productGetHelp && footerButton) {
          productGetHelp.innerHTML = footerButton.outerHTML;
        }
        
        const buttons = document.querySelectorAll('*[data-contact-popup-action="open"]');
        
        if (buttons) {
    
          for (let i = 0; i < buttons.length; i++) {
            const button = buttons[i];
    
            button.addEventListener('click', function() {
              popup.classList.add('Opened');
              document.body.classList.add('no-scroll');
            });
          }
        }
        
        const closes = popup.querySelectorAll('.ContactPopup__Close, .ContactPopup__Bg');
  
        for (let i = 0; i < closes.length; i++) {
          const close = closes[i];
  
          close.addEventListener('click', function() {
            popup.classList.remove('Opened');
            document.body.classList.remove('no-scroll');
          });
        }
        
        const form = popup.querySelector('form');
        const formButton = form.querySelector('.Form__Submit');

        form.addEventListener('submit', function(e) {
          e.preventDefault();
          formButton.setAttribute('disabled', 'disabled');
          
          const formAction = form.getAttribute('data-action');
          const formInputs = form.querySelectorAll('[name]');
          const formBody = window.themeObj.tools.getUrlString(window.themeObj.tools.formToJson(formInputs));
    
          fetch(formAction, {
            method: 'POST',
            body: formBody,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
              'Accept': 'text/html, */*; q=0.01',
              'X-Requested-With': 'XMLHttpRequest'
            }
          }).then(function(response) {
            popup.classList.add('Submitted');
  
          }).catch(function(error) {
            // console.error('contactPopup', 'error', error);
          });
        });
      }
    }
  },
  discountKlaviyoPopup: {
    id: 'VkQmYP',
    interval: false,
    translated: false,
    init: function() {
      window.themeObj.sections.discountKlaviyoPopup.interval = setInterval(window.themeObj.sections.discountKlaviyoPopup.event, 500);
      window.themeObj.sections.discountKlaviyoPopup.event();
    },
    event: function() {
      const id = 'VkQmYP';
      const form = document.querySelector('.klaviyo-form[data-testid="klaviyo-form-' + id + '"]');

      if (form && !window.themeObj.sections.discountKlaviyoPopup.translated) {
        window.themeObj.sections.discountKlaviyoPopup.translated = true;
        form.classList.add('translated');
        
        const data = document.querySelector('.KlaviyoForm__Data[data-id="' + id + '"]');
        
        if (data) {
          const rows = form.querySelectorAll('.ql-font-kanit');

          for (var i = 0; i < rows.length; i++) {

            if (!i) {
              const title = rows[i];
      
              if (title) {
                title.innerHTML = data.getAttribute('data-t-title');
              }
            
            } else if (i == 1) {
              const text = rows[i];
      
              if (text) {
                text.innerHTML = data.getAttribute('data-t-text');
              }
              
            } else if (i == 2) {
              const text = rows[i];
      
              if (text) {
                text.innerHTML = data.getAttribute('data-t-subtitle');
              }
            } 
          }
          
          const button = form.querySelector('button[type="button"]');
  
          if (button) {
            button.style.fontSize = '0px';
            button.innerHTML = '<span style="font-size: 18px;">' + data.getAttribute('data-t-button') + '</span>';
          }
  
          clearInterval(window.themeObj.sections.discountKlaviyoPopup.interval);
        }
      }
    }
  },
  tracktor: {
    interval: false,
    init: function() {
      window.themeObj.sections.tracktor.interval = setInterval(window.themeObj.sections.tracktor.event, 500);
      window.themeObj.sections.tracktor.event();
    },
    event: function() {
      const form = document.querySelector('#tracktorOrderForm');

      if (form) {
        const data = document.querySelector('.TracktorData');
        
        const title = form.querySelector('h1 > span');

        if (title) {
          title.innerHTML = data.getAttribute('data-t-title');
        }
        
        const orderNumber = form.querySelector('label[for="tracktorOrderName"]');

        if (orderNumber) {
          orderNumber.innerHTML = data.getAttribute('data-t-order-number');
        }
        
        const email = form.querySelector('label[for="tracktorOrderEmail"]');

        if (email) {
          email.innerHTML = data.getAttribute('data-t-email');
        }
        
        const button = form.querySelector('#tracktorTrack span');

        if (button) {
          button.innerHTML = data.getAttribute('data-t-button');
        }

        form.classList.add('translated');
          
        clearInterval(window.themeObj.sections.tracktor.interval);
      }
    }
  },
  footer: {
    klaviyo: {
      id: 'VWeMwS',
      interval: false,
      init: function() {
        window.themeObj.sections.footer.klaviyo.interval = setInterval(window.themeObj.sections.footer.klaviyo.event, 500);
        window.themeObj.sections.footer.klaviyo.event();
      },
      event: function() {
        const form = document.querySelector('.klaviyo-form[data-testid="klaviyo-form-' + window.themeObj.sections.footer.klaviyo.id + '"]');

        if (form && !form.classList.contains('translated')) {
          const data = form.parentNode;
          data.classList.add('translated');
          
          const title = form.querySelector('.ql-font-century-gothic');

          if (title) {
            title.innerHTML = data.getAttribute('data-t-title');
          }
          
          const text = form.querySelector('p + p > .ql-font-century-gothic');

          if (text) {
            text.innerHTML = data.getAttribute('data-t-text');
          }
          
          const button = form.querySelector('button[type="button"]');

          if (button) {
            button.innerHTML = data.getAttribute('data-t-button');
          }
          
          clearInterval(window.themeObj.sections.footer.klaviyo.interval);
        }
      }
    }
  }
};

if (!document.body.classList.contains('template-checkout')) {
  window.themeObj.sections.init();
}